import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import { Field, ModalInner } from './style';
import Button from '../../../components/Button';
import { updateStoreWithCategories } from '../../../graphql/mutations';
import { changeOrderHelper } from '@/utils/data';
import { HeaderSmall } from '../../../components/Text';
import Draggable from '../../../components/Draggable';
import Modal from '../../../components/Modal';
import { productCategories as productCategoriesQuery } from '../../../graphql/queries';
import i18n from '@/utils/i18n';
function StoreEditModal({ store, onClose }) {
  const [values, setValues] = useState(store);
  const [updateStoreMutation, { loading: updating }] = useMutation(
    updateStoreWithCategories,
  );

  const touchedValues = useMemo(
    () =>
      Object.keys(values).reduce((touched, key) => {
        if (store[key] !== values[key])
          return { ...touched, [key]: values[key] };
        return touched;
      }, {}),
    [store, values],
  );

  function handleChange({ target: { type, name, value } }) {
    const formattedValue =
      type === 'number' || type === 'select-one' ? +value : value;
    setValues({ ...values, [name]: formattedValue });
  }

  function handleSave() {
    if (Object.keys(touchedValues).length) {
      let item = { ...touchedValues };

      if (item.categories) {
        const { categories, ...rest } = item;
        item = {
          ...rest,
          store_layout: categories.map((category) => category.id),
        };
      }

      // remove __typename attribute
      if (item.opening_hours) {
        item.opening_hours = item.opening_hours.map((day) => ({
          day: day.day,
          time: day.time,
        }));
      }

      updateStoreMutation({
        variables: {
          id: store.id,
          store: item,
        },
        refetchQueries: [
          {
            query: productCategoriesQuery,
            variables: {
              id: store.id,
              filter: 'ALL',
            },
          },
        ],
        update: () => {
          onClose();
        },
      });
    }
  }

  function sortCategories(categoryId, targetCategoryId) {
    setValues({
      ...values,
      categories: changeOrderHelper(
        values.categories,
        'id',
        categoryId,
        targetCategoryId,
      ),
    });
  }

  function onDragStartCategories(event) {
    event.dataTransfer.setData('text/plain', event.target.id);
  }

  function onDragOverCategory(event) {
    event.preventDefault();
  }

  function onDropCategory(event) {
    const category = event.dataTransfer.getData('text');
    sortCategories(category, event.target.id);
    event.dataTransfer.clearData();
  }

  function onDayRemove(dayNumber) {
    setValues({
      ...values,
      opening_hours: values.opening_hours.filter(
        (day) => day.day !== dayNumber,
      ),
    });
  }

  function onDayChange(updatedDay) {
    setValues((oldValues) => {
      const newOpeningHours = [...(oldValues.opening_hours || [])];
      const index = newOpeningHours.findIndex(
        (openingHour) => openingHour.day === updatedDay.day,
      );
      if (index !== -1) {
        newOpeningHours[index] = updatedDay;
      } else {
        newOpeningHours.push(updatedDay);
      }
      newOpeningHours.sort((a, b) => a.day < b.day);
      return {
        ...oldValues,
        opening_hours: newOpeningHours,
      };
    });
  }

  return (
    <Modal onClose={onClose}>
      <ModalInner>
        {/*
        <Field>
          <pre>{store.id}</pre>
        </Field>
        <Field>
          <TextInput
                          placeholder={i18n.t('Common:storeNamePlaceholder')}
            name="name"
            value={values.name}
            onChange={handleChange}
          />
        </Field>
        */}
        <Field>
          <HeaderSmall>Change order of categories</HeaderSmall>
          {(values.categories || []).map((category) => (
            <Draggable
              key={category.id}
              id={category.id}
              draggable
              onDragStart={onDragStartCategories}
              onDragOver={onDragOverCategory}
              onDrop={onDropCategory}
            >
              {category.name}
            </Draggable>
          ))}
        </Field>

        {/*<TimeSpanPicker openingHours={values.opening_hours} onDayChange={onDayChange} onDayRemove={onDayRemove} /> */}

        <Button
          onClick={handleSave}
          loading={updating}
          disabled={!Object.keys(touchedValues).length}
        >
          {i18n.t('Common:save')}
        </Button>
      </ModalInner>
    </Modal>
  );
}

StoreEditModal.propTypes = {
  store: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default StoreEditModal;
